import type { AnnouncementRow } from '@rhwb/types';
import { callCloudRun } from './cloudRun';

/**
 * Read-only announcements for the runner dashboard.
 *
 * Wired now, silent until phase 2. Phase-1 announcements are
 * audience_kind = 'all_coaches', so the API's visibility predicate correctly
 * returns nothing here and AnnouncementsBanner renders null. Turning runners on
 * later is a value change on the publishing side — 'all_runners' or 'everyone' —
 * with no frontend work at all.
 */

interface FeedResponse {
  data: AnnouncementRow[];
  unread_count: number;
  version: string | null;
  unchanged?: boolean;
}

export async function fetchAnnouncements(): Promise<AnnouncementRow[]> {
  const result = await callCloudRun<FeedResponse>('/api/announcements/feed', { limit: 5 });
  return result?.data ?? [];
}

export async function markAnnouncementRead(id: string): Promise<void> {
  await callCloudRun('/api/announcements/read', { id });
}

export async function acknowledgeAnnouncement(id: string): Promise<void> {
  await callCloudRun('/api/announcements/ack', { id });
}
